import { supabase } from './supabase'

// Insert a notification row and optionally fire an SMS to the worker's phone.
// Fails soft — if SMS fails the notification row still lands.
//
// Usage:
//   notifyWorker({
//     userId, type, title, message, link, relatedId, businessId, sms: true
//   })
export async function notifyWorker({
  userId,
  type,
  title,
  message,
  link = null,
  relatedId = null,
  businessId = null,
  sms = true,
}) {
  if (!userId || !type || !title) return { error: 'missing userId/type/title' }

  // Look up the profile to get phone + default business
  let profile = null
  try {
    const { data } = await supabase
      .from('profiles')
      .select('id, phone, business_ids')
      .eq('id', userId)
      .single()
    profile = data
  } catch (e) {
    // continue — the notification row still gets written
  }

  const biz = businessId || (profile?.business_ids && profile.business_ids[0]) || 'pools'

  // Notification row
  const { error } = await supabase.from('notifications').insert({
    user_id: userId,
    type,
    title,
    message: message || null,
    link,
    related_id: relatedId,
    business_id: biz,
  })
  if (error) console.error('notifyWorker insert error', error.message)

  // SMS
  if (sms && profile?.phone) {
    try {
      const digits = profile.phone.replace(/\D/g, '')
      if (digits.length >= 10) {
        const to = '+1' + digits.slice(-10)
        const body = message ? title + ' — ' + message : title
        await fetch('/api/send-sms', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ to, message: body, business_id: biz }),
        })
      }
    } catch (e) {
      console.error('notifyWorker SMS error', e)
    }
  }

  return { ok: true }
}

// Fan-out helper: notify many users at once
export async function notifyWorkers(userIds, payload) {
  const uniq = Array.from(new Set((userIds || []).filter(Boolean)))
  await Promise.all(uniq.map((id) => notifyWorker({ ...payload, userId: id })))
}

// Look up owner IDs (for day-off request routing)
export async function getOwnerIds() {
  const { data } = await supabase
    .from('profiles')
    .select('id')
    .eq('role', 'owner')
    .eq('is_active', true)
  return (data || []).map((u) => u.id)
}
